import loadable from '@loadable/component';
// The key insight: Don't use fallbacks during SSR at all
// Instead, directly import the component for SSR
const CustomPriceRange =
    typeof window === 'undefined'
        ? // Server-side: import directly (synchronously)
          // eslint-disable-next-line import/no-dynamic-require
          require('./CustomPriceRange').default
        : // Client-side: use loadable with fallback
          loadable(
              () => import(/* webpackChunkName: "CustomPriceRangeChunks" */ './CustomPriceRange'),
              {
                  fallback: null,
              }
          );

export default CustomPriceRange;
